<div class="di-dossier-patient" [class.selected]="selected" (click)="onClick()">
	<div class="patient-container" *ngIf="patient">
		<lua-icone
			[isIcon]="true"
			[customIconName]="gender || 'homme'" 
			[color]="genderColor"
			height="40px"
			width="40px"
  		></lua-icone>
		<div class="patient-infos-container" *ngIf="patient">
			<p class="patient-name">{{nameString}}</p>
			<small class="patient-info">{{birthDateString}}</small>
			<small class="patient-info">{{ssnString}}</small>
			<small class="patient-info">{{addressString}}</small>
			<small class="patient-updated-date">{{updatedDateString}}</small>
		</div>
	</div>
</div>